import type { ElementType } from 'react';
import { useFormatTextToHtml } from '@r/hooks/use-format-text-to-html.ts';
import { cn } from '@r/utils/utils.ts';

interface FormattedHtmlProps {
  text: string | null | undefined;
  as?: ElementType;
  className?: string;
}

export const FormattedHtml = ({ text, as: Component = 'p', className }: FormattedHtmlProps) => {
  const formatTextToHtml = useFormatTextToHtml();

  if (!text) {
    return null;
  }

  return (
    <Component
      className={cn('[&_a]:text-primary [&_a]:hover:text-primary', className)}
      dangerouslySetInnerHTML={{ __html: formatTextToHtml(text) ?? '' }}
    />
  );
};
